import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { AppConstants } from '../AppConstants';

@Injectable()
export class UrlAppendHttpInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const curl = request.url.toLowerCase();

        const isExternal = curl.startsWith("http://") || curl.startsWith("https://");

        if (isExternal) {
            return next.handle(request);
        }

        const baseUrlStartPart = AppConstants.baseUrl + "/".toLowerCase();
        
        const isBase = curl.startsWith(baseUrlStartPart);
        
        if (isBase) {
            return next.handle(request);
        }

        const r = request.clone({ url: AppConstants.baseUrl + request.url });
        //req = Object.assign(req, r);

        return next.handle(r);
    }
}

